import { render, staticRenderFns } from "./eventCategory.vue?vue&type=template&id=ba67f24c&scoped=true"
import script from "./eventCategory.vue?vue&type=script&lang=js"
export * from "./eventCategory.vue?vue&type=script&lang=js"
import style0 from "./eventCategory.vue?vue&type=style&index=0&id=ba67f24c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba67f24c",
  null
  
)

export default component.exports